// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import { useFeatureFlags } from 'src/hooks/useFeatureFlag';

import styles from './ProductItemBase.scss';

type Props = {
  children: React.Node,
};

export default function ProductItemBase({
  children,
}: Props): React.MixedElement {
  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();

  if (FF_CART_OVERVIEW_NDS) {
    return (
      <Base
        tagName="li"
        flex
        flexCol
        className={styles.root}
        backgroundColor="white"
      >
        {children}
      </Base>
    );
  }

  return (
    <Base
      tagName="li"
      backgroundColor="white"
      paddingX="small"
      paddingBottom="small"
      flex
      flexCol
    >
      {children}
    </Base>
  );
}
